import {of as observableOf,  Observable, catchError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ErrorResponse, SuccessResponse } from '../../response';
import { IAddGroup, IAddGroupResponse, IGroup, IGroups, IUpdateGroup } from './groups-model';

@Injectable({
  providedIn: 'root'
})
export class GroupsService {

  private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}`; }
  private static readonly ENDPOINT = 'events/{eventId}/groups';

  constructor(private http: HttpClient) { }

  public getGroups(eventId: string): Observable<SuccessResponse<IGroup[]> | ErrorResponse> {
    return this.http
        .get<SuccessResponse<IGroups>>(GroupsService.URL + GroupsService.ENDPOINT.replace('{eventId}', eventId) + '/dropdowns' )
        .pipe(
        catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
  }

  public addNewGroup(group: IAddGroup): Observable<SuccessResponse<IAddGroupResponse> | ErrorResponse> {
    return this.http
        .post<SuccessResponse<IAddGroupResponse>>(GroupsService.URL + GroupsService.ENDPOINT.replace('{eventId}', group.eventId), group)
        .pipe(
        catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
  }

  public removeGroup(eventId: string, groupId: string): Observable<SuccessResponse<boolean> | ErrorResponse> {
    return this.http
        .delete<SuccessResponse<any>>(GroupsService.URL + GroupsService.ENDPOINT.replace('{eventId}', eventId) + '/' + groupId, {})
        .pipe(
        catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
  }

  public updateGroup(eventId: string, groupId: string, groupUpdate: IUpdateGroup): Observable<SuccessResponse<boolean> | ErrorResponse> {
    return this.http
        .put<SuccessResponse<boolean>>(GroupsService.URL +  GroupsService.ENDPOINT.replace('{eventId}', eventId) + '/' + groupId, groupUpdate)
        .pipe(
        catchError(x =>  observableOf(new ErrorResponse(x?.error?.messages))));
  }

}
